<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="firstName" id="firstName" type="text" pInputText>
            <label for="firstName">First Name</label>
            @for (validation of validationMessages.firstName; track validation) {
              <span>
                @if (form1.get('firstName').hasError(validation.type) && (form1.get('firstName').dirty || form1.get('firstName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="lastName" id="lastName" type="text" pInputText>
            <label for="lastName">Last Name</label>
            @for (validation of validationMessages.lastName; track validation) {
              <span>
                @if (form1.get('lastName').hasError(validation.type) && (form1.get('lastName').dirty || form1.get('lastName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="emailAddress" id="emailAddress" type="text" pInputText>
            <label for="emailAddress">Email Address</label>
            @for (validation of validationMessages.emailAddress; track validation) {
              <span>
                @if (form1.get('emailAddress').hasError(validation.type) && (form1.get('emailAddress').dirty || form1.get('emailAddress').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <!-- <p-inputMask formControlName="mobile" id="mobile" mask="(999) 999-9999" type="text">
          </p-inputMask> -->
          <input formControlName="mobile" id="mobile" type="text" pInputText>
          <label for="mobile">Mobile</label>
          @for (validation of validationMessages.mobile; track validation) {
            <span>
              @if (form1.get('mobile').hasError(validation.type) && (form1.get('mobile').dirty || form1.get('mobile').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="opsNotes" id="opsNotes" [rows]="1" pInputTextarea></textarea>
          <label for="opsNotes">Ops Notes</label>
          @for (validation of validationMessages.opsNotes; track validation) {
            <span>
              @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="relationships" formControlName="relationship" appendTo="body"
          optionLabel="name" optionValue="value" placeholder="Relationships"></p-dropdown>
          <label for="Relationships">Relationships</label>
          @for (validation of validationMessages.relationship; track validation) {
            <span>
              @if (form1.get('relationship').hasError(validation.type) && (form1.get('relationship').dirty || form1.get('relationship').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      @if (!ownerProfileGuestId) {
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="ownerProfiles" formControlName="ownerProfileId" appendTo="body"
              optionLabel="lastName" optionValue="ownerProfileId" (onChange)="selectOwnerProfile()"
              [filter]="true" filterBy="lastName" [showClear]="false" placeholder="Select Owner Profile">
            </p-dropdown>
            <label for="Select Owner Profile">Select Owner Profile</label>
            <span>
              @if (ownerProfileIdRequired) {
                <small class="p-invalid">Owner profile is required. (If owner
                  profile is not here in dropdown, so please add owner profile first and then add owner
                  profile guest)
                </small>
              }
            </span>
          </span>
        </div>
      }
    </div>
  </div>
</div>
<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (ownerProfileGuestId) {
            <button pButton class="btn-delete p-button-outlined p-button-danger"
            (click)="onFormDelete()">Delete OwnerProfileGuest</button>
          }
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          @if (!ownerProfileGuestId) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add OwnerProfileGuest</button>
          }

          @if (ownerProfileGuestId) {
            <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update OwnerProfileGuest</button>
          }
        </div>
      </div>
    </div>
  </div>
